import React from 'react';

import ActionsMenu from '../ActionsMenu/ActionsMenu';

// Components
import ViewDetailsButton from 'Shared/components/MeetingItemsContainer/partials/ViewDetailsButton';

// Styles
import './ActionsAreaForDiscussionTopic.scss';

type Props = {
  uuid: string;
  isSection: boolean;
  onAttachmentInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onArrowUpClick: Function;
  onHideAnimationTrigger?: Function;
};

function ActionsAreaForDiscussionTopic({
  uuid,
  onAttachmentInputChange,
  isSection,
  onArrowUpClick,
  onHideAnimationTrigger,
}: Props) {
  const baseClassName = 'ActionsAreaForDiscussionTopic';
  return (
    <div className={baseClassName}>
      <ActionsMenu
        uuid={uuid}
        onAttachmentAdd={onAttachmentInputChange}
        onArrowUpClick={onArrowUpClick}
        isSection={isSection}
        onHideAnimationTrigger={onHideAnimationTrigger}
      />
      {!isSection && <ViewDetailsButton uuid={uuid} />}
    </div>
  );
}

export default React.memo(ActionsAreaForDiscussionTopic);
